import { upcomingEngagements } from '@/mocks/schedule';
import ParallaxStrip from './ParallaxStrip';
import EngagementSection from './EngagementSection';
import PastEngagements from './PastEngagements';

const parallaxImages = [
  {
    url: 'https://storage.helloreaddy.io/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/5f1f413c-5568-4537-8a36-9cf029bbefa1_compressed_Screenshot-2026-08-26-at-10.51.54PM.webp',
    alt: 'Coffeehouse Music Salon',
  },
  {
    url: 'https://storage.helloreaddy.io/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/bc12ea29-5d93-4209-8e66-e6eac530f37c_compressed_wedding-balcony.webp',
    alt: "St. Paul's United Methodist Church",
  },
  {
    url: 'https://storage.helloreaddy.io/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/97d40945-00a6-4a53-abcd-bb8f5c75b2dd_compressed_19f2d7-20201026-1949-aeolian-skinner.webp',
    alt: 'East Texas Pipe Organ Festival',
  },
  {
    url: 'https://storage.helloreaddy.io/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/de911b67-3446-472a-9f29-1c9074eb1a4a_compressed_san-jose-opera.webp',
    alt: 'Opera San Jose',
  },
];

export default function ScheduleList() {
  return (
    <>
      {/* Upcoming Engagements label — positioned above the first parallax strip */}
      <div className="bg-background-50 px-6 md:px-10 lg:px-16 pt-8 md:pt-10 pb-2 md:pb-4">
        <div className="max-w-5xl mx-auto">
          <div className="flex items-center gap-3">
            <span className="block w-8 h-[1px] bg-foreground-300" />
            <span className="text-foreground-400 text-xs tracking-[0.2em] uppercase font-medium">
              Upcoming Engagements
            </span>
            <span className="block w-8 h-[1px] bg-foreground-300" />
          </div>
        </div>
      </div>

      {/* Upcoming Engagements with parallax transitions */}
      {upcomingEngagements.map((engagement, index) => (
        <div key={engagement.id}>
          {/* Parallax strip before each engagement */}
          <ParallaxStrip
            imageUrl={parallaxImages[index].url}
            alt={parallaxImages[index].alt}
          />
          {/* Full-screen engagement card */}
          <EngagementSection
            engagement={engagement}
            variant={index % 2 === 0 ? 'light' : 'dark'}
          />
        </div>
      ))}

      {/* Parallax transition into Past Engagements */}
      <ParallaxStrip
        imageUrl="https://storage.readdy-site.link/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/ac558317-ec60-49f8-ab3c-0bab56f574c8_compressed_SE248361.webp"
        alt="H.M.S. Pinafore — Nashville Opera"
      />

      {/* Past Engagements */}
      <PastEngagements />
    </>
  );
}